import { FC, ReactNode, useEffect } from 'react'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next, I18nextProvider } from 'react-i18next'
import dayjs from 'dayjs'
import 'dayjs/locale/pt'
import 'dayjs/locale/ar'
import 'dayjs/locale/de'
import enLocales from './en.json'
import ptLocales from './pt.json'
import arLocales from './ar.json'
import deLocales from './de.json'

const bundledResources = {
  en: { translations: enLocales },
  pt: { translations: ptLocales },
  ar: { translations: arLocales },
  de: { translations: deLocales },
}

export const RTL_LANGUAGES = ['ar']

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: bundledResources,
    lng: localStorage.getItem('i18nextLng') || 'en',
    supportedLngs: ['en', 'pt', 'ar', 'de'],
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
    saveMissing: true,
    saveMissingTo: 'all',
  })

const applyDirection = (lng: string) => {
  document.documentElement.lang = lng
  document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr'
  dayjs.locale(lng)
}

applyDirection(i18n.language)
i18n.on('languageChanged', applyDirection)

export const LocalizationProvider: FC<{ children: ReactNode }> = ({ children }) => {
  useEffect(() => {
    applyDirection(i18n.language)
  }, [])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
